import { useEffect } from "@wordpress/element";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { Button, TextField } from "vino/core";
import {
	ContactSchema,
	contactDefaultValues,
} from "vino/components/cart-checkout/models";
import { setCustomer } from "store/vino/eventBookingSlice";
import { Address } from "vino/components/cart-checkout/Checkout";

const BillingAddress = ({ onNext, onBack }) => {
	const dispatch = useDispatch();
	const customer = useSelector(({ vino }) => vino.eventBooking.customer);
	const user = useSelector(({ auth }) => auth.user);
	const { isUserLoaded, data } = user;
	const methods = useForm({
		mode: "onChange",
		defaultValues: contactDefaultValues,
		resolver: yupResolver(ContactSchema),
	});

	const { handleSubmit, reset, setValue } = methods;

	useEffect(() => {
		if (customer) {
			reset(customer);
		}
	}, [reset, customer]);

	useEffect(() => {
		if (!customer && isUserLoaded) {
			setValue("email", data.email);
			setValue("address.phone", data.phone);
		} else {
			setValue("addNewAddress", true);
		}
	}, [customer, user]);

	const handleAddressChange = (address) => {
		setValue("address", address);
	};

	const onSubmit = (model) => {
		dispatch(setCustomer(model));
		onNext();
	};

	const handleLoginNavigation = () => {
		location.href = "/login";
	};

	return (
		<Paper className="w-full rounded-20 shadow">
			<FormProvider {...methods}>
				<form
					noValidate
					className="flex flex-col w-full"
					onSubmit={handleSubmit(onSubmit)}
				>
					<div className="p-20">
						<div className="flex justify-between mb-20">
							<Typography className="text-16 font-medium ">
								Contact information
							</Typography>

							{!isUserLoaded && (
								<button onClick={handleLoginNavigation}>
									Login / Register
								</button>
							)}
						</div>
						<div className="w-full">
							{!isUserLoaded && (
								<TextField
									name="email"
									label="Email"
									required
									fullWidth
									autoFocus
								/>
							)}

							{isUserLoaded && <Typography>{data.email}</Typography>}
						</div>
					</div>

					<div className="w-full px-20">
						<Address title="Billing Address" onChange={handleAddressChange} />
						<div className="flex justify-between w-full my-20">
							<Button onClick={onBack}>
								<i className="fa-solid fa-angle-left mr-5"></i> Back
							</Button>
							<Button type="submit">
								Next <i className="fa-solid fa-angle-right ml-5"></i>
							</Button>
						</div>
					</div>
				</form>
			</FormProvider>
		</Paper>
	);
};

export default BillingAddress;
